import $ from 'jquery'; // Import jQuery module

const updateSelectedProductOption = {

	init: function() {
		// Run the function when the DOM content is fully loaded
		$(document).ready(() => {
			this.bindEvents();
		});
	},

	bindEvents: function() {
		function updateSelectedVariants() {
			$('.js-selected-options-cards').empty(); // Clear existing content
			$('.variations tr').each(function() {
				const label = $(this).find('label').text(); // Get label text
				let selectedVal = '';
				let selectedSKU = '';
				let selectedSize = '';
				let selectedEnd = '';
				let totalPrice = 0;
				let allEmpty = false;

				$('.image-variable-item.selected').each(function() {
					let priceText = $(this).find('.single-product__info-price').text().trim();
					if (priceText === '') {
						allEmpty = true;
						return false; // exit the loop if any price is empty
					}
					let price = parseFloat(priceText.replace(/[^\d.-]/g, ''));
					if (isNaN(price)) {
						allEmpty = true;
						return false; // exit the loop if any price is not a valid number
					}
					totalPrice += price;
				});

				if (allEmpty) {
					totalPrice = ''; // if any price is empty, set totalPrice to empty
					$('.single-product__info-total').hide();
					$('.single-product__info-total-amount').text('');
				} else {
					totalPrice = totalPrice.toFixed(2); // round totalPrice to 2 decimal places
					$('.single-product__info-total').show();
					$('.single-product__info-total-amount').text('$' + totalPrice);
				}

				if ($(this).find('.button-variable-items-wrapper').length > 0) {
					selectedVal = $(this).find('.selected').attr('termnicename'); // Get selected option text
					selectedSKU = $(this).find('.selected').attr('termsku'); // Get selected option text
					selectedSize = $(this).find('.button-variable-item.selected').attr('data-title'); // Get selected option text
					selectedEnd = selectedVal ? (selectedVal + ' ( SKU: ' + selectedSKU + ' )') : selectedSize;
				} else {
					selectedVal = $(this).find('.selected').find('.info-popup').find('.info-popup__name').text(); // Get selected option text
					selectedSKU = $(this).find('.selected').attr('termsku'); // Get selected option text
					selectedSize = $(this).find('.button-variable-item.selected').attr('data-title'); // Get selected option text
					selectedEnd = selectedVal ? (selectedVal + ' ( SKU: ' + selectedSKU + ' )') : selectedSize;
				}
				// Append selected variant to the div
				$('.js-selected-options-cards').append('<p class="single-product__info-selected-item">' + label + ': <span class="selected-val">' + selectedEnd + '</span></p>');
			});
		}
		$('.variations select').on('click', function() {
			updateSelectedVariants();
		});
		$(document).ready(function() {
			setTimeout(() => {
				if($('.single-product__info-loader').hasClass('active')) {
					$('.single-product__info-loader').removeClass('active');
				}
			}, 1200);
		});
	},

};

export default updateSelectedProductOption;
